import { IconType } from '../../icon/Icon';
import { toastService } from '../../toast/Toasts';
import { TooltipPlacement } from '../../tooltip/tooltip';
import Link, { LinkType, LinkVariant } from '../Link';
import './copyCode.scss';

type BaseSlideoutProps = {
  code: string;
  size?: 'tiny' | 'small' | 'medium' | 'large';
  smartListerLabels?: any;
};

const CopyCode = ({
  code,
  size = 'tiny',
  smartListerLabels,
}: BaseSlideoutProps) => {
  const handleCopy = () => {
    if (!code) {
      toastService.add({
        message: {
          type: 'error',
          description:
            smartListerLabels?.copyErrorMessage || 'No code to copy.',
          variant: 'light',
          actions: [
            {
              variant: LinkVariant.BUTTON,
              icon: { iconType: IconType.Close },
              isSmall: true,
              shouldClose: true,
            },
          ],
        },
      });
      return;
    }
    try {
      navigator.clipboard.writeText(code);
      toastService.add({
        message: {
          type: 'success',
          description:
            smartListerLabels?.copySuccessMessage || 'Copied to clipboard!',
          variant: 'light',
          actions: [
            {
              variant: LinkVariant.BUTTON,
              icon: { iconType: IconType.Close },
              isSmall: true,
              shouldClose: true,
            },
          ],
        },
      });
    } catch (error) {
      console.error('Failed to copy:', error);
      toastService.add({
        message: {
          type: 'error',
          description:
            smartListerLabels?.copyErrorMessage ||
            'Failed to copy to clipboard.',
          variant: 'light',
          actions: [
            {
              variant: LinkVariant.BUTTON,
              icon: { iconType: IconType.Close },
              isSmall: true,
              shouldClose: true,
            },
          ],
        },
      });
    }
  };

  return (
    <Link
      variant={LinkVariant.BUTTON}
      type={LinkType.SECONDARY}
      icon={{ iconType: IconType.Copy, className: `u-icon-${size}` }}
      iconPosition="right"
      className={`z-2 u-label-${size}`}
      iconTooltip={{
        content: smartListerLabels?.copyHover || 'Copy to clipboard',
        placement: TooltipPlacement.BOTTOM,
        zIndex: 10000,
        onClick: handleCopy,
      }}
      label={code}
      onClick={handleCopy}
    />
  );
};

export default CopyCode;
